/**
 * Version and cache utilities for PWA
 */

// Get build timestamp or version
export const getBuildVersion = (): string => {
  // You can set this during build process via environment variable
  return process.env.VITE_BUILD_TIME || Date.now().toString();
};

// Check if user is on old version and prompt refresh
export const checkForAppUpdate = (): Promise<boolean> => {
  return new Promise((resolve) => {
    // Check if there's a newer version available
    fetch('/index.html', { 
      cache: 'no-store',
      headers: {
        'Cache-Control': 'no-cache'
      }
    })
    .then(response => response.text())
    .then(html => {
      // Simple check - you could make this more sophisticated
      const currentHash = document.querySelector('script[src*="assets/index-"]')?.getAttribute('src');
      const newHash = html.match(/assets\/index-([^.]+)\.js/)?.[1];
      
      if (currentHash && newHash && !currentHash.includes(newHash)) {
        resolve(true); // Update available
      } else {
        resolve(false); // No update needed
      }
    })
    .catch(() => resolve(false));
  });
};

// Force refresh the app
export const forceAppRefresh = (): void => {
  // Clear all caches if possible
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then(registrations => {
      registrations.forEach(registration => registration.unregister());
    });
  }
  
  // Clear browser caches
  if ('caches' in window) {
    caches.keys().then(cacheNames => {
      cacheNames.forEach(cacheName => caches.delete(cacheName));
    });
  }
  
  // Force hard refresh
  window.location.reload();
};

// Show update notification
export const showUpdateNotification = (): boolean => {
  const userConfirmed = window.confirm(
    'Uygulamanın yeni bir sürümü mevcut. Güncellemek için sayfayı yeniden yüklemek istiyor musunuz?'
  );
  
  if (userConfirmed) {
    forceAppRefresh();
    return true;
  }
  
  return false;
}; 